import { keys } from '../styles/breakpoints';

export const getCurrentBreakpoint = state => state.layout.breakpoint;
export const isCurrentBreakpointAtLeast = (state, breakpoint) => (
  keys.indexOf(getCurrentBreakpoint(state)) >= keys.indexOf(breakpoint)
);
export const isBreakpointSet = state => state.layout.breakpointSet;
export const isCurrentBreakpointMobile = state => !isCurrentBreakpointAtLeast(state, 'md');
export const isSmallViewport = state => getCurrentBreakpoint(state) === 'sm';
